import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  FileBarChart2,
  CreditCard,
  RefreshCcw,
  UserX,
  ShoppingCart,
  Receipt,
  Headset,
  ChevronLeft,
  ChevronRight,
  type LucideIcon,
} from 'lucide-react';

export interface AdminNavItem {
  to: string;
  icon: LucideIcon;
  label: string;
}

const navItems: AdminNavItem[] = [
  { to: '/superadmin', icon: LayoutDashboard, label: 'Overview' },
  { to: '/superadmin/users', icon: Users, label: 'Users' },
  { to: '/superadmin/reports', icon: FileBarChart2, label: 'Reports & Checks' },
  { to: '/superadmin/orders', icon: ShoppingCart, label: 'Order Management' },
  { to: '/superadmin/subscriptions', icon: CreditCard, label: 'Subscriptions' },
  { to: '/superadmin/renewals', icon: RefreshCcw, label: 'Renewals' },
  { to: '/superadmin/lapsed', icon: UserX, label: 'Lapsed' },
  { to: '/superadmin/transactions', icon: Receipt, label: 'Transaction History' },
  { to: '/superadmin/tickets', icon: Headset, label: 'Support Tickets' },
  // { to: '/superadmin/settings', icon: Settings, label: 'Settings' },
];

export default function Sidebar({ collapsed, onToggle }: { collapsed: boolean; onToggle: () => void }) {
  const location = useLocation();

  return (
    <aside
      style={{
        width: collapsed ? 64 : 220,
        background: '#003c6c ',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        transition: 'width 0.25s ease',
        overflow: 'hidden',
      }}
    >
      {/* Brand row */}
      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 12px', borderBottom: '1px solid rgba(255,255,255,0.08)',
          minHeight: 60, flexShrink: 0,
        }}
      >
        <Link to="/superadmin" style={{ display: 'flex', alignItems: 'center', gap: 9, textDecoration: 'none', minWidth: 0 }}>
          <div style={{
            width: 34, height: 34, borderRadius: 9, background: '#ffffff',
            border: '1px solid rgba(255,255,255,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <img
              src="/manna-plag-favicon.png"
              alt="Manna Plag"
              style={{ width: 24, height: 24, objectFit: 'contain' }}
              onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
            />
          </div>
          {!collapsed && (
            <div style={{ minWidth: 0 }}>
              <p style={{ color: '#fff', fontWeight: 900, fontSize: 14, lineHeight: 1, letterSpacing: '-0.02em', whiteSpace: 'nowrap' }}>
                Manna Plag
              </p>
              <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 9, fontWeight: 700, letterSpacing: '0.08em', marginTop: 2 }}>
                ADMIN PANEL
              </p>
            </div>
          )}
        </Link>
        <button
          onClick={onToggle}
          style={{
            width: 26, height: 26, borderRadius: 6, border: 'none',
            background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0,
          }}
        >
          {collapsed ? <ChevronRight size={13} strokeWidth={2.5} /> : <ChevronLeft size={13} strokeWidth={2.5} />}
        </button>
      </div>

      {/* Nav items */}
      <nav style={{ flex: 1, overflowY: 'auto', padding: '8px 0', scrollbarWidth: 'none' }}>
        {navItems.map(item => {
          const active = item.to === '/superadmin'
            ? location.pathname === '/superadmin'
            : location.pathname.startsWith(item.to);
          const Icon = item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              title={collapsed ? item.label : undefined}
              style={{
                display: 'flex', alignItems: 'center', gap: 11,
                margin: '1px 8px', padding: '10px 12px', borderRadius: 8,
                textDecoration: 'none', fontSize: 13, fontWeight: active ? 700 : 500,
                color: active ? '#ffffff' : 'rgba(255,255,255,0.65)',
                background: active ? 'rgba(255,255,255,0.14)' : 'transparent',
                transition: 'all 0.13s', whiteSpace: 'nowrap',
              }}
            >
              <Icon size={18} strokeWidth={active ? 2.4 : 2} style={{ flexShrink: 0 }} aria-hidden="true" />
              {!collapsed && <span style={{ flex: 1 }}>{item.label}</span>}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
